import { forwardRef, Ref, useContext, useState } from "react";

import { Button, useWindowSize } from "@newsela/angelou";

import { RefContext } from "@/base/NewselaGlobalLayoutV2/RefContext.provider";
import { FilterHeader } from "@/search/Langston/FilterPanel/FilterHeader";
import {
  backToTopButtonCss,
  getFilterContainerPositionCss,
} from "@/search/Langston/SearchPage/SearchPage.styles";
import { StandardsSearchProvider } from "@/search/Langston/StandardsSearchProvider";
import { SEARCH_LUNA_KEY } from "../useInfiniteSearchQuery/useInfiniteSearchQuery";
import { Filters } from "./filters";
import {
  getFilterPanelContainerCss,
  getFilterPanelFiltersSectionVisibilityCss,
} from "./FilterPanel.styles";
import { FilterControls } from "./FilterControls";
import { LunaFilterPanel } from "./LunaFilterPanel";

export const FilterPanel = forwardRef((_, ref: Ref<HTMLDivElement>) => {
  const { height: windowHeight } = useWindowSize();
  const { layoutRef } = useContext(RefContext);

  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);

  const onClickBackToTop = () => {
    if (layoutRef?.current) {
      layoutRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const isSearchWithLunaEnabled =
    globalThis.window?.localStorage.getItem(SEARCH_LUNA_KEY) === "true";

  const renderDefaultFilterPanel = () => {
    return (
      <div css={getFilterContainerPositionCss}>
        <div css={getFilterPanelContainerCss(isFilterPanelOpen)} ref={ref}>
          <FilterHeader
            isFilterPanelOpen={isFilterPanelOpen}
            setIsFilterPanelOpen={setIsFilterPanelOpen}
          />

          <div
            css={getFilterPanelFiltersSectionVisibilityCss(
              isFilterPanelOpen,
              windowHeight,
            )}
          >
            <FilterControls />
            <Filters />
          </div>
        </div>

        <Button
          __cssFor={backToTopButtonCss}
          onClick={onClickBackToTop}
          flavor={Button.flavors.primary}
          dataProps={{ "data-qa-selector": "search-scroll-to-top" }}
        >
          Scroll back to top
        </Button>
      </div>
    );
  };

  const renderSearchWithLunaFilterPanel = () => {
    return <LunaFilterPanel />;
  };
  return (
    <StandardsSearchProvider>
      {isSearchWithLunaEnabled
        ? renderSearchWithLunaFilterPanel()
        : renderDefaultFilterPanel()}
    </StandardsSearchProvider>
  );
});
